import type { Transition } from 'framer-motion';

export const spring: Transition = { type: 'spring', stiffness: 400, damping: 35 };
export const softSpring: Transition = { type: 'spring', stiffness: 300, damping: 32 };
export const tap = { scale: 0.98 };
